import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6249f4f9&scoped=true&lang=pug"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249f4f9",
  null
  
)

export default component.exports